import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { getCurrentDate } from "@/publicjs/currentDate";
import { getCompany } from "@/publicjs/company";
import { idLocalStore } from "@/publicjs/localStorage";
import { closeAlert, errorActions, uploadData } from "@/alerts";
import stylesExcel from "@/publicjs/stylesExcel";

export const exportToExcel = async (data, dateStart, dateEnd, summary) => {
  try {
    await uploadData(
      "Generando reporte",
      "Espera un momento mientras preparamos el reporte de caja chica...",
    );

    const dataCompany = await getCompany(await idLocalStore());
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("CAJA CHICA");

    const styles = {
      title: {
        font: {
          bold: true,
          size: stylesExcel.fontSize.xl,
          color: { argb: stylesExcel.color.darkAlt },
        },
        alignment: { horizontal: "center", vertical: "middle" },
      },
      subtitle: {
        font: {
          bold: true,
          size: stylesExcel.fontSize.md,
          color: { argb: stylesExcel.color.darkAlt },
        },
        alignment: { horizontal: "center", vertical: "middle" },
      },
      header: {
        font: {
          bold: true,
          size: stylesExcel.fontSize.sm,
          color: { argb: stylesExcel.color.white },
        },
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: stylesExcel.color.darkAlt },
        },
      },
    };

    worksheet.mergeCells("A1:H1");
    worksheet.getCell("A1").value = "REPORTE DE CAJA CHICA";
    worksheet.getCell("A1").style = styles.title;

    worksheet.mergeCells("A2:H2");
    worksheet.getCell(
      "A2",
    ).value = `SUCURSAL: ${dataCompany.storeName.toUpperCase()}`;
    worksheet.getCell("A2").style = styles.subtitle;

    worksheet.mergeCells("A3:H3");
    worksheet.getCell("A3").value = `RANGO: ${dateStart} / ${dateEnd}`;
    worksheet.getCell("A3").style = styles.subtitle;

    worksheet.mergeCells("A4:H4");
    worksheet.getCell("A4").value = `TOTAL DESEMBOLSADO: ${
      summary.total_desembolsado || 0
    } | MOVIMIENTOS: ${summary.total_movimientos || 0}`;
    worksheet.getCell("A4").style = styles.subtitle;

    const headers = [
      "CAJA",
      "RESPONSABLE",
      "REFERENCIA",
      "BENEFICIARIO",
      "DEPARTAMENTO",
      "CONCEPTO",
      "MONTO",
      "FECHA",
    ];

    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.style = styles.header;
    });

    data.forEach((rowData) => {
      worksheet.addRow([
        rowData.idcaja_chica,
        rowData.nombres,
        rowData.numero_referencia || "---",
        rowData.beneficiario || "---",
        rowData.departamento || "---",
        rowData.concepto,
        Number(rowData.monto),
        rowData.fecha_de_desembolso,
      ]);
    });

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 14 ? 14 : maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `${getCurrentDate()}-caja-chica.xlsx`);
    await closeAlert();
  } catch (error) {
    errorActions("No pudimos generar el reporte en Excel de caja chica");
  }
};
